import { NgModule } from '@angular/core';
import { CalendarModule } from 'angular-calendar';
import { SharedModule } from '../../core/modules/shared.module';
import { EguardCalendarComponent } from './common/calendar/calendar-view/calendar.component';
import { EguardCalendarEventFormatialogComponent } from './common/calendar/event-form/event-form.component';
import { ReportsComponent } from './common/reports/reports.component';
import { CaseTypeReportsComponent } from './common/reports/case-type/case.type.reports';
import { CaseStatusReportsComponent } from './common/reports/case-status/case.status.reports';
import { ActiveCasesReportsComponent } from './common/reports/active-cases/active.cases.component';
import { PaidCasesComponent } from './common/reports/paid-cases/paid.cases.component';
import { CalendarCasesComponent } from './common/reports/calendar-cases/calendar.cases.component';
import { CaseAgeComponent } from './common/reports/case-age/case.age.component';
import { EguardPaymentsComponent } from './common/payments/payments.component';
import { EguardChangePasswordComponent } from './common/change-password/change-password.component';
import { EguardError404Component } from '../shared/components/errors/404/error-404.component';
import { EguardError500Component } from '../shared/components/errors/500/error-500.component';
import { EguardWidgetModule } from '../../core/components/widget/widget.module';
import { CoreModule } from '../shared/services/core-service.module';
import { NotifyPopupComponent } from './common/notify-popup/notify-popup.component';
import { CaseActionComponent } from './common/case-action/case-action.component';
import { CommonRoutes } from './common.route';
import { logoutComponent } from './common/logout/logout.component';
import { EguardValidationService } from '../../core/components/validation/validation.service';
import { NewPetitionComponent } from './common/new-petition/new-petition.component';
import { EguardRecentActivityComponent } from './common/recentActivity/recentActivity.component';
import { EguardCaseViewComponent } from './common/case-view/case-view.component';
import { AlertListComponent } from './common/alertList/alertList.component';
import { AlertFormComponent } from './common/alertList/alertForm/alertForm.component';
import { DownloadUploadComponent } from './common/downloadUpload/downloadUpload.component';
import { OpenAlertComponent } from './common/alertList/openAlert/openAlert.component';
import { EguardClerkCasesComponent } from './common/cases/clerk-cases.component';
import { EguardOrganizationsComponent } from './common/organizations/organization-list/organizations.component';
import { EguardOrganizationFormComponent } from './common/organizations/organization-form/organization-form.component';
import { EguardClerkUserFormComponent } from './common/userfrom/clerk-userform.component';
import { EguardClerkUsersComponent } from './common/users/clerk-users.component';
import { LoadingComponent } from './loading/loading.component';
import { DeeComponent } from './dee/dee.component';
export * from '../shared/services/password.strength';
import { CalendarWeekHoursViewModule } from 'angular-calendar-week-hours-view';
import { PdfViewComponent } from './common/pdfView/pdfView.component';
import { SevenOneComponent } from './common/sevenOne/sevenOne.component';
import { EguardPlaidComponent } from './common/plaid/plaid.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CaseListComponent } from './caseList/caseList.component';
import { CommentsComponent } from './comments/comments.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { PreSignService } from 'app/main/shared/services/preSign.service';
import { MatTabNav } from '@angular/material';
import { SevenOneMainComponent } from './common/seven-one/seven-one-main/seven-one-main.component';
import { SpentAmountComponent } from './common/seven-one/component/spent-amount/spent-amount.component';
import { ReceiveAmountComponent } from './common/seven-one/component/receive-amount/receive-amount.component';
import { AssignGuardianDialogComponent } from './common/assign-guardian-dialog/assign-guardian-dialog.component';
import { CheckrService } from '../shared/services/checkr.service';
import { CacheService } from 'app/services/cache.service';
import { TodoTabModule } from './common/todo-tab/todo-tab.module';
import { ModeOfPaymentsDialogComponent } from './common/dailog/mode-of-payments-dialog/mode-of-payments-dialog.component';
import { FormsService } from '../shared/services/forms.service';
import { PaymentPrefDialogComponent } from './common/dialogs/payment-pref-dialog-component/payment-pref-dialog-component.component';
import { AchMicroDepositVerifyComponent } from './common/dialogs/ach-micro-deposit-verify/ach-micro-deposit-verify.component';
import { PdfModalViewComponent } from './common/pdf-modal-view/pdf-modal-view.component';
import { PaymentFormComponent } from './common/payments/payment-form/payment-form.component';
import { HelpComponent } from './help/help.component';
import { CourtDatesComponent } from './court-dates/court-dates.component';
import { AddComponent } from './court-dates/add/add.component';
import { DocketCaseComponent } from './court-dates/docket-case/docket-case.component';


export const MaterialModules = [
];
@NgModule({
    declarations: [
        EguardCalendarEventFormatialogComponent,
        EguardCalendarComponent,
        EguardError404Component,
        EguardError500Component,
        EguardClerkCasesComponent,
        EguardOrganizationsComponent,
        EguardOrganizationFormComponent,
        EguardClerkUserFormComponent,
        EguardClerkUsersComponent,
        NotifyPopupComponent,
        CaseActionComponent,
        EguardChangePasswordComponent,
        EguardPaymentsComponent,
        logoutComponent,
        ReportsComponent,
        CaseTypeReportsComponent,
        CaseStatusReportsComponent,
        ActiveCasesReportsComponent,
        PaidCasesComponent,
        CalendarCasesComponent,
        CaseAgeComponent,
        NewPetitionComponent,
        EguardRecentActivityComponent,
        EguardCaseViewComponent,
        AlertListComponent,
        AlertFormComponent,
        OpenAlertComponent,
        PdfViewComponent,
        DownloadUploadComponent,
        SevenOneComponent,
        EguardPlaidComponent,
        DashboardComponent,
        CaseListComponent,
        DeeComponent,
        LoadingComponent,
        CommentsComponent,
        SevenOneMainComponent,
        SpentAmountComponent,
        ReceiveAmountComponent,
        AssignGuardianDialogComponent,
        ModeOfPaymentsDialogComponent,
        PaymentPrefDialogComponent,
        AchMicroDepositVerifyComponent,
        PdfModalViewComponent,
        PaymentFormComponent,
        HelpComponent,
        CourtDatesComponent,
        AddComponent,
        DocketCaseComponent
    ],

    imports: [
        SharedModule,
        EguardWidgetModule,
        CoreModule.forRoot(),
        CalendarModule.forRoot(),
        CalendarWeekHoursViewModule,
        CommonRoutes,
        TodoTabModule,
        NoopAnimationsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        
    ],

    exports: [
        AlertListComponent,
        EguardRecentActivityComponent,
        CommentsComponent
    ],

    entryComponents: [
        EguardCalendarEventFormatialogComponent,
        AlertFormComponent,
        OpenAlertComponent,
        NotifyPopupComponent,
        CaseActionComponent,
        DownloadUploadComponent,
        EguardClerkUserFormComponent,
        EguardChangePasswordComponent,
        AssignGuardianDialogComponent,
        ModeOfPaymentsDialogComponent,
        PaymentPrefDialogComponent,
        AchMicroDepositVerifyComponent,
        PdfModalViewComponent,
        PaymentFormComponent,
        AddComponent,
        DocketCaseComponent
    ],

    providers: [
        EguardValidationService,
        PreSignService,
        MatTabNav,
        CheckrService,
        CacheService,
        FormsService
    ]
})

export class CommonModule {

}



// WEBPACK FOOTER //
// ./src/app/main/content/common.module.ts